/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} TuesdayInputs */

const en_tuesday = /** @type {(inputs: TuesdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tuesday`)
};

const de_tuesday = /** @type {(inputs: TuesdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dienstag`)
};

/**
* | output |
* | --- |
* | "Tuesday" |
*
* @param {TuesdayInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tuesday = /** @type {((inputs?: TuesdayInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<TuesdayInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tuesday(inputs)
	return de_tuesday(inputs)
});